var l = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M43.76 43.76V6.26a6.24 6.24 0 1112.48 0v37.5h37.5a6.24 6.24 0 110 12.48h-37.5v37.5a6.24 6.24 0 11-12.48 0v-37.5H6.26a6.24 6.24 0 110-12.48h37.5z", "fill-rule": "nonzero" } }] }, name: "plus", theme: "filled" };
export {
  l as default
};
